const BN_DIGITS = '০১২৩৪৫৬৭৮৯';

export function toBn(value: string | number): string {
  return String(value).replace(/[0-9]/g, (d) => BN_DIGITS[Number(d)]);
}

export function bnNum(value: number): string {
  return toBn(value.toLocaleString('en-IN'));
}

export function fromBn(value: string): string {
  return value.replace(/[০-৯]/g, (d) => String(BN_DIGITS.indexOf(d)));
}

export function bnPercent(value: number, digits = 1): string {
  return toBn(value.toFixed(digits)) + '%';
}
